import { PolicyDocument, PolicyId } from '@estercare/ester-shared'
import { appConfig } from '../../../../config'

export const getPolicyDocument = async ({
  policyId,
  language,
  version,
}: {
  policyId: PolicyId
  language: string
  version?: string
}): Promise<PolicyDocument> => {
  const params = new URLSearchParams({ language })
  if (version) params.set('version', version)
  const response = await fetch(`${appConfig.serverRootUrl}/api/public/policies/${policyId}?${params}`, {
    headers: {
      'content-type': 'application/json',
    },
  })
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data?.message || `Failed to get policy ${policyId}`)
  }
  return response.json()
}
